import { PartnerEditPage } from "@/features/rso/pages/PartnerEdit";
import React from "react";

const MatchEdit = () => {
  return <PartnerEditPage />;
};

export default MatchEdit;
